import React, { useEffect, useState } from 'react'
import Table from '../Table/Table'
import Table_Buttons from '../Table_Button/Table_button'
import { toast } from 'react-toastify'
import { API } from '../../Redux/actions/API'
import Navbar from '../Navbar/Navbar'
import { useNavigate } from 'react-router-dom'

function All_member() {
  let user = ''
  // let active = 1
  // let status1 = 2;
  const [referralApi, setreferralApi] = useState([])
  const [leftreferralApi, setleftreferralApi] = useState([])
  const [select, setSelect] = useState('2')
  const [search, setSearch] = useState('')
  const [fromdate, setFromdate] = useState('')
  const [todate, setTodate] = useState('')
  // const [active, setActive] = useState('')
  const [currentPage, setcurrentPage] = useState(1)
  const [listPerpage, setlistPerpage] = useState(10)
  const [currentPage2, setcurrentPage2] = useState(1)
  const [listPerpage2, setlistPerpage2] = useState(10)
  const [allMember, setAllMember] = useState('')
  let navigate= useNavigate()

  let arrayLeft = []
  const referral_API = async () => {
    try {
      const user = localStorage?.getItem('user')
      let responceRight = await API?.post('/AllMembers', {
        "uid": search,
        "PageIndex": "1",
        "fromDate": fromdate,
        "toDate": todate,
        "topup": select,
     

      })

      console.log('My_Team', responceRight.data.data)
      // setBlockStatus(responceRight.data.data)
      responceRight = responceRight.data.data
      setleftreferralApi([]);
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index+1,
          id: `${item?.uid} `,
          Position: item?.password,
          sponser_id: item?.sponser_id,
          date_time: `${item?.date} `,
          status: `${item?.idtypes} `,
          status: `${item?.s} `,
          top_updates: `${item?.top_update1} `,
          blockstatus: `${item?.blockstatus}`,
          staking: `${item?.blockbtn}`,
          packageamount: `${item?.packagename}`,

        })

        setleftreferralApi(arrayLeft)
      })
    } catch (e) {
      console.log('Error While calling Myteam API', e)
    }
  }

  // const hendelClick = () => {
  //   if (stakingData == 'active') {
  //     setActive('0')
  //   } else {
  //     setActive('1')
  //   }
  // }

  const Status_active = async (id ,blockstatus) => {
    try {
      console.log('statevalue', blockstatus)
      let status_value = blockstatus
      let status = 0
      
      if (status_value =="Active"){
        status = 0;
      }
      else{
        status=1;
      }
      console.log("status_value_id=>",id);
      console.log("status_value_status=>",status);
      let res = await API?.post('/Changestatus', {
        uid: id,
        status: status,
      })
      console.log("res_block",res);
      if (res.data.success = "true") {
        alert('Update Successfully ..')
        referral_API()
      } else {
        toast.error('Somthing Wrong')
      }
      console.log('MyActive', res.data.data)
    } catch (e) {
      console.log('Error While calling Myteam API', e)
    }
  }

  useEffect(() => {
    referral_API()
  }, [])

  const indexOfLastPost = currentPage * listPerpage
  const indexOfFirstPage = indexOfLastPost - listPerpage
  const indexOfLastPost2 = currentPage2 * listPerpage2
  const indexOfFirstPage2 = indexOfLastPost2 - listPerpage2
  const currentPost = referralApi.slice(indexOfFirstPage, indexOfLastPost)
  const currentPostleft = leftreferralApi.slice(indexOfFirstPage2, indexOfLastPost2)

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: 'S.No.', accessor: 'sr' },
      { Header: 'User ID', accessor: 'id' },
      { Header: 'Address', accessor: 'Position' },
      // {
      //   Header: "Edit",
      //   accessor: "edit",
      //   Cell: ({ cell }) => (
      //     <button
      //       class="btn btn-primary"
      //       id={cell.row.values.staking.id}
      //       onClick={() => {
      //         navigate(`/Edit_Menber_List?userId=${cell.row.values.id}&walletAddress=${cell.row.values.Position}`);
      //       }}
      //     >
      //       Edit
      //     </button>
      //   ),
      // },

      { Header: 'Sponser Id', accessor: 'sponser_id' },
      { Header: 'Package Amount', accessor: 'packageamount' },
      { Header: ' Activation Date & Time', accessor: 'top_updates' },
      { Header: ' Reg. Date & Time', accessor: 'date_time' },
      // { Header: '	ID Type', accessor: 'status' },
      {
        Header: 'Current Status',
        accessor: 'blockstatus',
      },
      {
        Header: 'Action',
        accessor: 'staking',
        Cell: ({ cell }) => (
          <button
            style={{ color: 'black' }}
            value={cell.row.values.staking}
            onClick={(e) => {
              Status_active(cell.row.values.id,cell.row.values.blockstatus)
            }}
          >
            {cell.row.values.staking}
          </button>
        ),
      },

    ],
  })


  
  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="container">
            {/* <!-- Inline Form --> */}
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-primary">
                  <div class="panel-heading">
                    <h4 class="panel-title">Member List</h4>
                  </div>
                  <div class="panel-body">
                    <form ng-submit="SearchUserid();" class="ng-pristine ng-valid ng-valid-maxlength">
                      <div class="form-inline" role="form">
                        <div class="col-md-12">
                          <div class="col-md-4">
                            <input
                              type="text"
                              id="txtuid"
                              ng-model="p.uid"
                              onChange={(e) => setSearch(e.target.value)}
                              class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                              placeholder="Enter Wallet Address"
                            />
                            &nbsp;&nbsp;
                          </div>
                          <div class="col-md-2">
                            <select
                              class="form-control ng-pristine ng-untouched ng-valid ng-empty"
                              onChange={(e) => {
                                setSelect(e.target.value)
                              }}
                              ng-model="p.user_type"
                              ng-init="p.user_type=''"
                            >
                              <option value="2" selected="selected">
                                All
                              </option>
                              <option value="1">Active</option>
                              <option value="0">In-active</option>
                            </select>
                          </div>
                          <div class="col-md-2 col-xs-12">
                            <input
                              type="button"
                              id="btnsearch"
                              onClick={() => {
                                referral_API()
                              }}
                              class="btn btn-sm btn-primary"
                              value="Search"
                            />
                            &nbsp;&nbsp;
                          </div>
                          &nbsp;&nbsp;
                        </div>
                      </div>
                    </form>
                    <div class="col-md-12"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-default">
                  <div class="panel-body" style={{ overflow: 'scroll' }}>
                    <Table data={currentPostleft} columns={my_team.cols} />

                    <Table_Buttons
                      indexOfFirstPage={indexOfFirstPage2}
                      indexOfLastPost={indexOfLastPost2}
                      setcurrentPage={setcurrentPage2}
                      currentPage={currentPage2}
                      totalData={leftreferralApi.length}
                      listPerpage={listPerpage2}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default All_member
